
import { Button } from "@/components/ui/button";
import { useNavigate, useLocation } from "react-router-dom";


export function EmployerAppNav() {
  const navigate = useNavigate();
  const location = useLocation();

  const isActivePage = (path: string) => {
    // Handle both exact match and dashboard routes
    if (path === "/" || path === "/dashboard") {
      return location.pathname === "/" || location.pathname === "/dashboard";
    }
    return location.pathname === path;
  };

  const handleNavigation = (path: string, e: React.MouseEvent) => {
    e.stopPropagation(); // Prevent event propagation to parent elements
    navigate(path);
  };

  return (
    <div className="flex items-center space-x-4">
      <Button
        variant="ghost"
        className={`transition-colors duration-200 ${
          isActivePage("/") || isActivePage("/dashboard")
            ? "text-foreground font-semibold" 
            : "text-muted-foreground hover:text-foreground hover:bg-accent"
        }`}
        style={isActivePage("/") || isActivePage("/dashboard") ? { backgroundColor: `hsl(var(--nav-active))` } : undefined}
        onClick={(e) => handleNavigation("/dashboard", e)}
      >
        Dashboard
      </Button>
      <Button
        variant="ghost"
        className={`transition-colors duration-200 ${
          isActivePage("/test-management")
            ? "text-foreground font-semibold"
            : "text-muted-foreground hover:text-foreground hover:bg-accent"
        }`}
        style={isActivePage("/test-management") ? { backgroundColor: `hsl(var(--nav-active))` } : undefined}
        onClick={(e) => handleNavigation("/test-management", e)}
      >
        Tests
      </Button>
    </div>
  );
}
